import { TextKey } from '@mews-commander/enums';
import { Toggle } from '@optimus-web/core';
import { useCurrentUser } from '@mews-commander/core';
import { SecurityCard } from '../SecurityCard';
import { usePasswordGatedDialog } from '../VerifyPasswordDialog';
import { PIN_ENABLE_DIALOG_NAME, PinEnableDialog } from './PinEnableDialog';
import { PIN_DISABLE_DIALOG_NAME, PinDisableDialog } from './PinDisableDialog';

export const PinSetting = () => {
    const openPasswordGatedDialog = usePasswordGatedDialog();
    const { hasUnlockPin: hasPin = false } = useCurrentUser();

    const handleChangeSwitch = (enabling: boolean) => {
        const [PinDialog, dialogId, textKey] = enabling
            ? [PinEnableDialog, PIN_ENABLE_DIALOG_NAME, TextKey.PinPasswordGateDescription]
            : [PinDisableDialog, PIN_DISABLE_DIALOG_NAME, TextKey.PinDeletePasswordGateDescription];

        openPasswordGatedDialog(PinDialog, dialogId, textKey);
    };

    return (
        <SecurityCard
            primaryText={TextKey.Pin}
            secondaryText={TextKey.PinLoginDescription}
            action={<Toggle checked={hasPin} />}
            onClick={() => handleChangeSwitch(!hasPin)}
        />
    );
};
